const re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;

export default password => {
    return re.test(password);
};



// WEBPACK FOOTER //
// ./src/utils/validatePasswordPolicy.js